export default "/fonts/Acrom-Medium.woff?78555b1040221f793384cdbfd8848481";